/**
 * The sweep request status which is used to show the sweep dialog based on the current state
 */
var SweepRequestStatus;
(function (SweepRequestStatus) {
    SweepRequestStatus[SweepRequestStatus["NotInitiated"] = 0] = "NotInitiated";
    SweepRequestStatus[SweepRequestStatus["Pending"] = 1] = "Pending";
    SweepRequestStatus[SweepRequestStatus["Complete"] = 2] = "Complete";
    SweepRequestStatus[SweepRequestStatus["Error"] = 3] = "Error";
})(SweepRequestStatus || (SweepRequestStatus = {}));
export default SweepRequestStatus;
//# sourceMappingURL=SweepRequestStatus.js.map